import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, DownloadIcon, StarIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden" style={{
    background: 'linear-gradient(180deg, #0A1628 0%, #1B3A6B 60%, #0A1628 100%)'
  }} data-id="element-27">
      {/* Background radial glow */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 80% 60% at 50% 40%, rgba(201,168,76,0.08) 0%, transparent 70%)'
    }} data-id="element-28" />

      {/* Top banner image */}
      <div className="w-full relative overflow-hidden" style={{
      maxHeight: '220px'
    }} data-id="element-29">
        <img src="https://cdn.magicpatterns.com/uploads/s3sy7oxnt6WVAeFNYSFsvi/BANNER.png" alt="Escudo de Fe - Guía Espiritual en dispositivos" className="w-full object-cover object-center" style={{
        maxHeight: '220px'
      }} data-id="element-30" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, transparent 30%, #0A1628 100%)'
      }} data-id="element-31" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 py-8 text-center" data-id="element-32">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 mb-4 px-3 py-1.5 rounded-full border border-gold-warm" style={{
        background: 'rgba(201,168,76,0.1)'
      }} data-id="element-33">
          <ShieldIcon size={13} className="text-gold-warm" data-id="element-34" />
          <span className="font-cinzel text-xs text-gold-warm tracking-widest uppercase" style={{
          fontSize: '10px'
        }} data-id="element-35">
            Protección Espiritual para tu Familia
          </span>
        </motion.div>

        {/* Main headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="font-cinzel font-black text-2xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight mb-4" style={{
        color: '#FFF8E7'
      }} data-id="element-36">
          ¿Sientes que el miedo y la inseguridad están{' '}
          <span className="shimmer" data-id="element-37">robando la paz de tu hogar?</span>
        </motion.h1>

        {/* Divider */}
        <motion.div initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="divider-gold mx-auto mb-5" style={{
        width: '160px'
      }} data-id="element-38" />

        {/* Sub-headline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="font-lato text-base sm:text-lg md:text-xl leading-relaxed mb-6 max-w-3xl mx-auto" style={{
        color: '#FFF8E7',
        opacity: 0.9
      }} data-id="element-39">
          Protege a los que más amas con el{' '}
          <strong className="text-gold-light" data-id="element-40">Escudo de Fe</strong>: El manual
          digital de oración diaria que activa una muralla espiritual sobre tus
          hijos, tu casa y tus finanzas en{' '}
          <strong className="text-gold-light" data-id="element-41">menos de 5 minutos.</strong>
        </motion.p>

        {/* Book mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.85
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="flex justify-center mb-6" data-id="element-42">
          <div className="relative" data-id="element-43">
            <div className="absolute inset-0 rounded-lg blur-2xl" style={{
            background: 'rgba(201,168,76,0.25)',
            transform: 'scale(0.9) translateY(10px)'
          }} data-id="element-44" />
            <img src="https://cdn.magicpatterns.com/uploads/wymb9NwAMjTpTr6jfXwsX9/ART_ESCUDO_DE_FE.png" alt="Escudo de Fe - Manual Digital de Oración" className="relative z-10 rounded-lg" style={{
            maxWidth: '180px',
            width: '100%'
          }} data-id="element-45" />
          </div>
        </motion.div>

        {/* Stars */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.9
      }} className="flex items-center justify-center gap-1 mb-5" data-id="element-46">
          {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} fill="#C9A84C" className="text-gold-warm" data-id="element-47" />)}
          <span className="font-lato text-xs text-gold-warm ml-2" data-id="element-48">
            +2,400 familias protegidas
          </span>
        </motion.div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1.0
      }} data-id="element-49">
          <button className="cta-button pulse-glow inline-flex items-center gap-2 px-5 py-4 rounded-lg text-navy-deep font-cinzel font-bold text-sm sm:text-base md:text-lg uppercase tracking-wide w-full sm:w-auto justify-center" style={{
          background: 'linear-gradient(135deg, #C9A84C 0%, #F0D080 50%, #C9A84C 100%)'
        }} aria-label="Comprar Escudo de Fe por $297 MXN" onClick={() => {
          document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-50">
            <ShieldIcon size={18} className="flex-shrink-0" data-id="element-51" />
            <span data-id="element-52">¡SÍ, QUIERO PROTEGER A MI FAMILIA — $297 MXN!</span>
          </button>
          <p className="font-lato text-xs mt-2" style={{
          color: 'rgba(255,248,231,0.5)'
        }} data-id="element-53">
            Acceso inmediato · Correo y WhatsApp
          </p>
        </motion.div>
      </div>
    </section>;
}